import React, { Component } from "react";
import { isEqual } from "lodash";
import "./CustomSelect.css";

function getValidationObj(DomNode) {
  let validationObj = DomNode?.validity || {};
  let errors = {};
  for (let key in validationObj) {
    errors[key] = validationObj[key];
  }
  return errors;
}

class CustomSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.runValidation = this.runValidation.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.handleOptionClick = this.handleOptionClick.bind(this);
    this.inputRef = React.createRef();
  }

  runValidation(DomNode) {
    this.props.onValidation && this.props.onValidation(getValidationObj(DomNode));
    this.props.validationObject && this.props.validationObject(DomNode);
  }

  handleChange(value) {
    if (this.props.type === "number") {
      value = Number(value);
    }
    this.props.onChange && this.props.onChange(value);
    this.runValidation(this.inputRef.current);
    this.setState({ isOpen: false });
  }

  handleBlur(e) {
    this.props.onBlur && this.props.onBlur();
    this.setState({ isOpen: false });
  }

  componentDidMount() {
    this.runValidation(this.inputRef.current);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.value, this.props.value)) {
      this.runValidation(this.inputRef.current);
    }
    if (prevProps.required !== this.props.required) {
      this.runValidation(this.inputRef.current, "zone");
    }
  }

  handleDisabledOptions = (value) => {
    return this.props.handleOptionDisable ? this.props.handleOptionDisable(value) : false;
  };

  toggleDropdown() {
    if (!this.props.disabled && !this.props.readOnly) {
      this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
    }
  }

  handleOptionClick(option) {
    if (!this.handleDisabledOptions(option.value ? option.value : option)) {
      this.handleChange(option.value ? option.value : option);
    }
  }

  render() {
    const { props } = this;
    let value = (Array.isArray(props.value) ? props.value[0] : props.value) || "";
    if (props.type === "number" && value) {
      value = Number(value);
    }

    const selectedOption = props.options.find(
      (option) => (option.value ? option.value : option) === value
    );
    const displayValue = selectedOption
      ? selectedOption.text
        ? selectedOption.text
        : selectedOption
      : props.placeholder;

    return (
      <span className="CustomSelect">
        <input
          type="text"
          style={{ display: "none" }}
          ref={this.inputRef}
          value={value}
          required={props.required}
          readOnly
        />
        <div
          className={`custom-select ${props.disabled || props.readOnly ? "disabled" : ""} ${
            this.state.isOpen ? "open" : ""
          }`}
          onBlur={this.handleBlur}
          tabIndex={0}
        >
          <div
            className="selected-value"
            onClick={this.toggleDropdown}
          >
            {typeof displayValue === "string" ? displayValue : displayValue}
          </div>
          {this.state.isOpen && (
            <ul className="options-list">
              {props.options.map((option) => {
                if (typeof option === "object" && !option.text) {
                  return null;
                }
                const optionValue = option.value ? option.value : option;
                const optionText = option.text ? option.text : option;
                const isDisabled = this.handleDisabledOptions(optionValue);
                return (
                  <li
                    key={optionValue}
                    className={`option ${isDisabled ? "disabled" : ""} ${
                      optionValue === value ? "selected" : ""
                    }`}
                    onClick={() => this.handleOptionClick(option)}
                  >
                    {optionText}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </span>
    );
  }
}

CustomSelect.defaultProps = {
  options: [],
  disabled: false,
};

export default CustomSelect;